// Guarda de PRIORIDADE do Back entre o árbitro da pilha (DetailOverlayHost) e
// modais ANINHADOS dentro de uma camada (o TrailerOverlay, que abre por cima da
// ficha). Ver docs/plan/tv-ficha-overlay.md §5 e o contrato do review do P0.
//
// O PROBLEMA: o árbitro engole o Back em CAPTURE (window+document) com
// stopImmediatePropagation. O TrailerOverlay TAMBÉM escuta Back em capture (é
// obrigatório: o iframe do YouTube rouba o foco real do DOM e só a captura pega o
// Back). Como o árbitro registra ANTES (no boot), ele rodaria primeiro e fecharia
// a FICHA INTEIRA em vez de só o trailer.
//
// A SOLUÇÃO: enquanto um modal aninhado está aberto, ele registra um interceptor.
// O árbitro, vendo um interceptor ativo, NÃO engole o Back — deixa o evento seguir
// pro handler (capture, registrado depois) do modal, que fecha só a si mesmo. Sem
// interceptor, o árbitro trata o Back normal (pop da pilha). Contador (não bool)
// pra empilhar modais aninhados com segurança.

let interceptors = 0

/** Um modal aninhado assume o Back. Devolve o liberador (chame no unmount). */
export function pushBackInterceptor(): () => void {
  interceptors += 1
  let released = false
  return () => {
    if (released) return
    released = true
    interceptors = Math.max(0, interceptors - 1)
  }
}

/** O árbitro checa isto: há um modal aninhado querendo o Back primeiro? */
export function hasBackInterceptor(): boolean {
  return interceptors > 0
}

/** Só pra teste — zera o contador entre casos. */
export function __resetBackInterceptors(): void {
  interceptors = 0
}
